import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { blogPosts } from '../data/blogData';

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Find the blog post with matching id
  const post = blogPosts.find(p => p.id === id);

  if (!post) {
    return (
      <Container className="section-padding text-center">
        <Row>
          <Col lg={8} className="mx-auto">
            <h2 className="mb-4">Blog Post Not Found</h2>
            <p className="mb-4" style={{ color: '#666' }}>
              The blog post you're looking for doesn't exist or has been moved.
            </p>
            <Button onClick={() => navigate('/blog')} className="btn-gold">
              Back to Blog
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }

  // Get related posts (excluding current post)
  // const relatedPosts = blogPosts.filter(p => p.id !== id).slice(0, 2);
  // Get related posts
  const relatedPosts = blogPosts.filter(p => p.id !== id).slice(0, 2);

  // Share data
  const shareUrl = window.location.origin + window.location.pathname;
  const shareTitle = post.title;
  const shareText = `Check out this article from Golf4 International: ${shareTitle}`;

  // Copy link function
  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    alert("Link copied to clipboard!");
  };

  return (
    <>
      {/* Hero Section */}
      <section style={{
        height: '60vh',
        background: `linear-gradient(rgba(31, 61, 43, 0.8), rgba(31, 61, 43, 0.9)), url(${post.imageUrl}) center/cover no-repeat`,
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container>
          <Row>
            <Col lg={10} className="text-white">
              <div className="mb-3">
                <span className="badge rounded-pill px-3 py-2" style={{
                  backgroundColor: 'var(--muted-gold)',
                  fontSize: '0.9rem'
                }}>
                  {post.category}
                </span>
              </div>
              <h1 className="display-4 fw-bold mb-4" style={{ color: "#B59A5A" }}>{post.title}</h1>
              <div className="d-flex align-items-center">
                <span className="me-3">{post.date}</span>
                <span>•</span>
                <span className="ms-3">{post.readTime} read</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Blog Content */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              {/* Author Info */}
              <div className="d-flex align-items-center mb-5 p-4 bg-soft-sage rounded">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  marginRight: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <span style={{ fontSize: '1.5rem', color: 'var(--muted-gold)' }}>👤</span>
                </div>
                <div>
                  <h4 className="h5 mb-1">{post.author?.name || 'Golf4International Editorial Team'}</h4>
                  <p style={{ color: '#666' }} className="mb-0">
                    {post.author?.role || 'Experts in golf technology, coaching, and industry trends'}
                  </p>
                </div>
              </div>

              {/* Blog Content */}
              <div className="blog-content mb-5" style={{
                color: '#333',
                lineHeight: '1.8',
                fontSize: '1.1rem'
              }}>
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
              </div>

              {/* Share Buttons */}
              {/* Share Buttons */}
              <div className="border-top border-bottom py-4 mb-5">
                <h5 className="h6 mb-3">Share this article:</h5>

                <div className="d-flex flex-wrap gap-2">

                  {/* Facebook */}
                  <button
                    className="btn-gold"
                    style={{ padding: "8px 20px" }}
                    onClick={() =>
                      window.open(
                        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fab fa-facebook me-2"></i>Facebook
                  </button>

                  {/* LinkedIn */}
                  <button
                    className="btn-gold"
                    style={{ padding: "8px 20px" }}
                    onClick={() =>
                      window.open(
                        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fab fa-linkedin me-2"></i>LinkedIn
                  </button>

                  {/* Twitter / X */}
                  <button
                    className="btn-gold"
                    style={{ padding: "8px 20px" }}
                    onClick={() =>
                      window.open(
                        `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fab fa-twitter me-2"></i>Twitter
                  </button>

                  {/* WhatsApp */}
                  <button
                    className="btn-gold"
                    style={{ padding: "8px 20px" }}
                    onClick={() =>
                      window.open(
                        `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + " " + shareUrl)}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fab fa-whatsapp me-2"></i>WhatsApp
                  </button>

                </div>
              </div>
              {/* <div className="border-top border-bottom py-4 mb-5">
                <h5 className="h6 mb-3">Share this article:</h5>
                <div className="d-flex flex-wrap gap-2">
                  <button className="btn-gold" style={{ padding: '8px 20px' }}>
                    <i className="fab fa-twitter me-2"></i>Twitter
                  </button>
                  <button className="btn-gold" style={{ padding: '8px 20px' }}>
                    <i className="fab fa-facebook me-2"></i>Facebook
                  </button>
                  <button className="btn-gold" style={{ padding: '8px 20px' }}>
                    <i className="fab fa-linkedin me-2"></i>LinkedIn
                  </button>
                  <button className="btn-gold" style={{ padding: '8px 20px' }}>
                    <i className="fas fa-envelope me-2"></i>Email
                  </button>
                </div>
              </div> */}

              {/* Navigation */}
              <div className="d-flex justify-content-between mb-5">
                <Button
                  onClick={() => navigate('/blog')}
                  className="btn-gold"
                >
                  ← Back to Blog
                </Button>
                <Button
                  onClick={() => navigate('/contact')}
                  className="btn-gold-filled"
                >
                  Contact Us →
                </Button>
              </div>
            </Col>
          </Row>

          {/* Related Posts */}
          {relatedPosts.length > 0 && (
            <>
              <Row className="mb-4">
                <Col>
                  <h3 className="h4">Related Articles</h3>
                </Col>
              </Row>

              <Row className="g-4">
                {relatedPosts.map((relatedPost) => (
                  <Col md={6} key={relatedPost.id}>
                    <div
                      className="card-modern h-100 border-0"
                      onClick={() => navigate(`/blog/${relatedPost.id}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        style={{
                          height: '200px',
                          background: `url(${relatedPost.imageUrl}) center/cover no-repeat`
                        }}
                      />
                      <div className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <small className="text-muted">{relatedPost.date}</small>
                          <small className="text-muted">{relatedPost.readTime} read</small>
                        </div>
                        <h4 className="h5 mb-3">{relatedPost.title}</h4>
                        <p className="text-muted mb-0">{relatedPost.excerpt}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Container>
      </section>

      {/* Newsletter CTA */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h3 className="h4 mb-3">Never Miss an Update</h3>
              <p style={{ color: '#666' }} className="mb-4">
                Subscribe to our newsletter for regular golf insights, tips, and exclusive content.
              </p>
              <div className="input-group mx-auto" style={{ maxWidth: '500px' }}>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  style={{ padding: '12px' }}
                />
                <button className="btn-gold-filled" type="button">
                  Subscribe
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BlogDetail;